import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
    static defaultProps = {
        elem: 'div',
    };

    render() {
        const { className, glyph, elem: Elem, ...rest } = this.props;

        const iconClasses = classNames('icon', className);

        return (
            <Elem className={iconClasses} dangerouslySetInnerHTML={{ __html: glyph }} {...rest} />
        );
    }
}

export default Icon;



// WEBPACK FOOTER //
// ./components/Icon/Icon.jsx